let config = {
  emailjs: {
    serviceID: "service_g5minvs",
    templateID: "template_m83cc84",
    userID: "moI3Xt1BmlUaVAy5J"
  }
};

export default config;
